var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button } from '../../button';
import { styled } from '../../styled';
var appBarButtonName = 'QuantumAppBarButton';
export var Root = styled(Button, { name: appBarButtonName, slot: 'Root' })(function (_a) {
    var theme = _a.theme, variant = _a.variant, ownerState = _a.ownerState;
    var _b = theme.mixins.appBarAction(), focus = _b.focus, hover = _b.hover, activeStyle = _b.active, root = _b.root;
    return __assign(__assign(__assign(__assign(__assign({}, root), { whiteSpace: 'nowrap', textTransform: 'initial', minHeight: theme.typography.pxToRem(36), paddingTop: 0, paddingBottom: 0, fontWeight: theme.typography.fontWeightRegular, boxSizing: 'border-box', '&:focus,&.Mui-focus': focus, '&:hover,&.Mui-hover': hover, '&:active,&.Mui-active': activeStyle, color: 'inherit' }), (variant === 'outlined' && __assign(__assign({ borderColor: theme.tokens.color_border_inverse_static }, (ownerState.active && {
        borderColor: theme.tokens.color_border_state_neutral,
    })), { '&:hover,&.Mui-hover': {
            borderColor: theme.tokens.color_border_state_neutral,
        } }))), (variant === 'link' && {
        padding: theme.spacing(0, 1, 0, 1.5),
        border: '2px solid transparent',
    })), (ownerState.active && __assign({}, activeStyle)));
});
export var AppBarButton = React.forwardRef(function (props, ref) {
    var color = props.color, className = props.className, active = props.active, _a = props.variant, variant = _a === void 0 ? 'link' : _a, _b = props.ButtonProps, ButtonProps = _b === void 0 ? {} : _b, children = props.children, 
    // remove to avoid sending to IconButton
    propClasses = props.classes, rootProps = __rest(props, ["color", "className", "active", "variant", "ButtonProps", "children", "classes"]);
    return (React.createElement(Root, __assign({ ref: ref, ownerState: { active: active }, variant: variant }, rootProps, { color: "inherit" }, ButtonProps), children));
});
